import Joi from 'joi';
import {
  inputSearchTypes,
  defaultInputSearchTypes,
  DateRangeInput,
} from 'utils/search';

const schema = {
  skip: Joi.number().default(0),
  sort: Joi.string().default('updated-desc'),
  limit: Joi.number().default(24),
  query: Joi.string().allow(''),
  productionId: Joi.array().items(Joi.number()),
  productionType: Joi.array().items(Joi.string()).allow(null).default([]),
  propertyId: Joi.array().items(Joi.number()),
  searchType: Joi.string()
    .valid(...inputSearchTypes.map((searchType) => searchType.value))
    .default(defaultInputSearchTypes.value),
  status: Joi.array()
    .items(Joi.string())
    .default(['taped', 'to-tape', 'general', 'completed']),
  releaseDateRange: DateRangeInput,
  premiereNetworkId: Joi.array().items(Joi.number()).default([]),
  premiereNetworkCountry: Joi.string().allow('', null).default(null),
  assignedToId: Joi.number().allow(null),
  channels: Joi.array()
    .items(
      Joi.object({
        channel: Joi.string(),
        classes: Joi.array()
          .items(
            Joi.object({
              class: Joi.string(),
              genres: Joi.array()
                .items(
                  Joi.object({
                    genre: Joi.string(),
                    subgenres: Joi.array().items(Joi.string()).allow(null),
                  }),
                )
                .allow(null),
            }),
          )
          .allow(null),
      }),
    )
    .allow(null)
    .default([]),
  watchId: Joi.number().allow(null),
  connectedToWatch: Joi.string().valid('all', 'yes', 'no').default('all'),
  connectedToSpotlight: Joi.string().valid('all', 'yes', 'no').default('all'),
  createdBySpotlight: Joi.boolean().default(false),
  updatedBySpotlight: Joi.boolean().default(false),
  notCreatedBySpotlight: Joi.boolean().default(false),
  affectedByMerge: Joi.boolean().default(false),

  placementsAttr: Joi.object().keys({
    hasImage: Joi.boolean(),
    hasVideo: Joi.boolean(),
  }),
  placementsQuality: Joi.array().items(Joi.string()).default([]),
};

export default schema;

export const getDefaultValue = () => schema;
